import { BCMSRecord, Workflow, useBCMSContext } from "@bcm-dev/bcms-vite";
import { Account, Transaction, TransferTransaction } from "model";
import React from "react";
import QuickTransferItem from "./classes/QuickTransferItem";

import { QuickTransferContent } from "components/pages/AccountSummaryPage/components/QuickTransferWidget";
// Steps of the workflow
const steps = [ QuickTransferContent ];

/**
 * @function QuickTransferWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for the quick transfer workflow
 * @example
 * <QuickTransferWorkflow />
 */
export default function QuickTransferWorkflow(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor([ Account, Transaction, TransferTransaction ], controller);

    const value = getDefaultTransfer();
    return <Workflow value={ value } steps={ steps } />
}
/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultTransfer
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultTransfer = success => ({ 
    "transfer" : QuickTransferItem.init({}),    
    "success" : false
});